<div class="emails-type-list">
  <ng-container *ngIf="!loadingSpinner">
    <div class="email-type">
      <div class="email-type-title">
        System Access
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let accessButton of accessButtons; let i = index" (click)="editAccess(accessButton, i)">
            {{accessButton.title}}
          </button>
          <!--          ONLY FOR DEV-->
          <!--          <button mat-button class="email-changer-button"-->
          <!--                  (click)="createAccess()">Create New-->
          <!--          </button>-->
        </div>
      </div>
    </div>
  </ng-container>

  <div class="loading-body" *ngIf="loadingSpinner">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

</div>

